import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  AfterViewInit,
  ViewChild,
  TemplateRef, OnDestroy
} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {Subject, first, Subscription} from 'rxjs';
import { finalize, debounceTime } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

import { RoleModel, NpiModel, ResultInviteModel } from 'src/app/models/invites/invites.model';
import { GridAction, GridColumn } from 'src/app/modules/shared/components/generic-grid/generic-grid.component';

import { ScheduleService } from '../../services/accounts/schedule.service';
import { PracticeChangeService } from '../../services/general/practice-change-service.service';
import { PageTitleService } from '../../services/page-title/page-title.service';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { PatientService } from '../../services/patient/patient.service';
import { PracticeService } from '../../services/accounts/practice.service';
import { AlertMessageService } from '../shared/services/alert-message.service';
import { InvitesService } from 'src/app/services/invites/invites.services';
import { FormHelperService } from 'src/app/modules/shared/services/form-helper.service';
import { ThemeModeService } from 'src/app/_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { FormUtils } from '../../services/general/form-utils.service';
import { ChangePassword2Component } from '../change-password/components/change-password2/change-password2.component';

// ✅ Models/servicios para Accounts
import { ResultAccounts } from 'src/app/models/accounts/accountsetting.model';
import { AccountsService } from 'src/app/services/accountssetting/accounts.service';
import { AccountsHttpService } from 'src/app/services/accountssetting/https/accounts-http.service';

// ✅ Modal select role
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterselectroleComponent } from '../dashboard/components/filter-select-role/filter-selectrole.component';
import {roleszService} from "../../services/accountssetting/roleslist.service";
import {IroleszModel} from "../../models/accounts/role.model";
import {HttpParams} from "@angular/common/http";

interface User {
  name: string;
  role: string;
  status: boolean;
  lastLogin: string; // mm/dd/yyyy
}

interface NewInvite {
  role: string;
  npi: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
}

type ModalName = 'changePassword' | 'invite' | 'accounts';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit, AfterViewInit, OnDestroy {
  // -------------------- Modal flags --------------------
  isChangePasswordModalOpen = false;
  isInviteModalOpen = false;
  isAccountsModalOpen = false;
  private openModalCount = 0;

  @ViewChild('statusTpl', { static: true }) statusTpl!: TemplateRef<any>;
  @ViewChild('createdTpl', { static: true }) createdTpl!: TemplateRef<any>;
  @ViewChild('actionTpl', { static: true }) actionTpl!: TemplateRef<any>;
  @ViewChild('changePassword') changePasswordCmp?: ChangePassword2Component;
  resultRole: IroleszModel[] = [];


  // Templates usados por Accounts
  @ViewChild('statusToggleTpl', { static: false }) statusToggleTpl!: TemplateRef<any>;
  @ViewChild('lastLoginTpl',   { static: false }) lastLoginTpl!: TemplateRef<any>;
  @ViewChild('roleCellTpl', { static: false }) roleCellTpl!: TemplateRef<any>;
  // Estado edición de role
  editingRoleId: number | null = null;
  tempSelectedRoleId: any = null;
  savingRoleId: number | null = null;
  moment = moment;

  // -------------------- Invites (Add / Sent) --------------------
  inviteForm!: FormGroup;
    npiList: NpiModel[] = [];
  selectedRole: string | undefined;
  selectedNpi: any | null = null;
  inviteLoading = false;
  newInvite: NewInvite = { role: '', npi: '', firstName: '', lastName: '', phone: '', email: '' };
  menuItems: MenuItem[] = [];
  inviteTab: 'add' | 'sent' = 'add';

  // --- Invites Grid (Sent)
  columns: GridColumn[] = [];
  limit = 20;
  offset = 0;
  sort = '';
  isModal = false;

  sentFilter = '';
  private inviteFilterTimer: any;
  resendingId: number | null = null;
  revokingId: number | null = null;

  result: ResultInviteModel = new ResultInviteModel();

  public isEditing = false;
  public editingInviteId: number | null = null;

  // -------------------- Accounts (server-side grid) --------------------
  accountCols: GridColumn[] = [];

  resultAll: ResultAccounts = new ResultAccounts();

  // Estado común
  sortField = '';
  sortDir: 'asc' | 'desc' = 'desc';
  valor: string = '';
  subjectSearch: Subject<string> = new Subject();

  loading = false;
  enableordisable: any;
  accountid: any;

  // -------------------- Toggles --------------------
  twoFactorEnabled = false;
  darkModeEnabled = false;

  // (Solo para la tabla dummy antigua - se mantiene por compatibilidad)
  filteredUsers: User[] = [];
  pagedUsers: User[] = [];
  userFilterTerm = '';
  private filterTimer: any;
  private subscription!: Subscription;
  currentPage = 1;
  usersPerPage = 5;
  totalPages = 1;
  sortColumn: keyof User = 'name';
  sortDirection: 'asc' | 'desc' = 'asc';
  openMenuId: number | null = null;

  constructor(
    private scheduleService: ScheduleService,
    private invitesService: InvitesService,
    private cdr: ChangeDetectorRef,
    private practiceChangeService: PracticeChangeService,
    private pageTitle: PageTitleService,
    private dashboardService: DashboardService,
    private alertMessage: AlertMessageService,
    private alertService: AlertMessageService,
    private patientService: PatientService,
    private translate: TranslateService,
    private practiceService: PracticeService,
    private roleService: roleszService,
    private fb: FormBuilder,
    private router: Router,
    public formHelper: FormHelperService,

    // Inyecciones para Accounts
    private accountService: AccountsService,
    private accountsHttpService: AccountsHttpService,
    private modalService: NgbModal,
    private themeModeService: ThemeModeService
  ) {}

  // =========================================================
  // Lifecycles
  // =========================================================
  ngOnInit(): void {
    this.loadSettings();
    this.pageTitle.set('Settings');
    this.buildInviteForm();

    // 🔎 Debounce del filtro de Accounts
    this.subjectSearch.pipe(debounceTime(400)).subscribe(() => {
      this.offset = 0;
      this.refresh();
    });

    // 🔄 Cambios de práctica -> refrescar Accounts
    this.subscription= this.practiceChangeService.practiceChange$.subscribe(practice => {
      localStorage.setItem('practiceId', practice.id?.toString() || '0');
      localStorage.setItem('practiceName', practice.name?.toString() || '');
      this.offset = 0;
      this.refresh();
    });
  }

  ngAfterViewInit(): void {
    // Invites "Sent"
    this.columns = [
      { field: 'email',     header: 'Email',     width: '240px', sortable: false, sortFieldName: 'email' },
      { field: 'role.name', header: 'Role',      width: '160px', sortable: false, sortFieldName: 'role_name' },
      { field: 'created',   header: 'Sent At',   width: '160px', sortable: false, sortFieldName: 'created', template: this.createdTpl },
      { field: 'status',    header: 'Status',    width: '140px', sortable: false, sortFieldName: 'status',  template: this.statusTpl },
    ];

    // Accounts
    this.accountCols = [
      { field: 'full_name', header: 'Name', width: '240px', sortable: false, sortFieldName: 'full_name' },
      { field: 'role.name', header: 'Role', width: '160px', sortable: false, sortFieldName: 'role.name' },
      { field: 'is_verified', header: 'Status', width: '120px', sortable: false, sortFieldName: 'is_verified', template: this.statusToggleTpl },
      { field: 'last_login', header: 'Last Login', width: '160px', sortable: false, sortFieldName: 'last_login', template: this.lastLoginTpl },
      { field: 'action', header: 'Action', width: '240px', template: this.actionTpl } // 👈 aquí se renderiza el botón/dropdown
    ];


    this.cdr.detectChanges();

    if (this.inviteTab === 'sent') {
      this.lazyLoadData({ first: 0, rows: this.limit, sortField: null, sortOrder: 0, sortParam: null } as any);
    }
  }
  startRoleEdit(row: any): void {
    // cargar roles si no están
    if (!this.resultRole || this.resultRole.length === 0) {
      this.loadRoles(false);
    }
    this.editingRoleId = row.id;
    this.tempSelectedRoleId = row?.role?.id ?? row?.role_id ?? null;
    this.cdr.detectChanges();
  }

  cancelRoleEdit(): void {
    this.editingRoleId = null;
    this.tempSelectedRoleId = null;
    this.cdr.detectChanges();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  applyRoleEdit(): void {
    if (this.editingRoleId == null || this.tempSelectedRoleId == null) {
      this.alertMessage.showToast('Please select a role', 'error');
      return;
    }

    const accountId = this.editingRoleId;
    const newRoleId = this.tempSelectedRoleId;
    this.savingRoleId = accountId;

    // Llama a tu endpoint para actualizar el rol
    this.roleService.changuserrole(accountId, newRoleId, localStorage.getItem("practiceId") || '0').pipe(
      finalize(() => {
        this.savingRoleId = null;
        this.editingRoleId = null;
        this.refresh()
        this.cdr.detectChanges();
      })
    ).subscribe({
      next: () => {
        this.savingRoleId = null
        this.alertMessage.showToast('Account role changed successfully.', 'success');
      },
      error: (error) => {
        this.savingRoleId = null
        this.alertMessage.showToast(

          `Error changing user role: ${error?.message || ''}`, "error"
        );
      }

    });

  }

  onChangePwdCompleted(): void {
    this.closeModal('changePassword');
  }

  // =========================================================
  // Accounts: Grid server-side
  // =========================================================
  searchPress(): void {
    this.subjectSearch.next(this.valor || '');
  }

  onAccountLazy(event: any): void {
    // Paginación
    this.limit  = event?.rows  ?? this.limit;
    this.offset = event?.first ?? 0;

    // Orden
    const rawSortParam = (event?.sortParam || event?.sortField || '') as string;
    if (rawSortParam) {
      const base = rawSortParam.replace(/^-+/, '');
      const isDesc = String(event?.sortParam || '').startsWith('-') || event?.sortOrder === -1;
      this.sortField = base;
      this.sortDir   = isDesc ? 'desc' : 'asc';
    } else {
      this.sortField = '';
      this.sortDir   = 'desc';
    }

    this.refresh();
  }

  onAccountAction(e: { actionId: string; row: any }) {
    if (e.actionId === 'select-role') {
      this.openFilter(e.row?.id, e.row?.role_id ?? e.row?.roleId);
    }
  }

  confirmToggle(ev: MouseEvent, cb: HTMLInputElement, row: any): void {
    // 1) Bloquear el toggle visual inmediato
    ev.preventDefault();
    ev.stopPropagation();

    const current = !!row?.is_verified;
    const next = !current;

    // 2) Preguntar
    const title = this.translate.instant('ACCOUNTS.CONFIRMATION.TITLE');
    const message = this.translate.instant(
      next
        ? 'ACCOUNTS.CONFIRMATION.ENABLE'
        : 'ACCOUNTS.CONFIRMATION.DISABLE'
    );

    this.alertService
      .showQuestion(
        title,
        message,
        this.translate.instant('GENERAL.YES'),
        this.translate.instant('GENERAL.NO')
      )
      .then((result: any) => {
        if (result?.isConfirmed) {
          // 3) Usuario confirmó: actualiza UI y servidor
          row.is_verified = next;
          cb.checked = next;               // mantener el input sincronizado
          this.toggleStatus(next, row.id); // tu llamada a API
        } else {
          // 4) Canceló: deja todo como estaba
          row.is_verified = current;
          cb.checked = current;
        }
      });
  }


  toggleStatus(value: boolean, id: any): void {
    this.accountsHttpService
      .updateStatus(id, value ? 'enable' : 'disable', localStorage.getItem('practiceId') || '0')
      .subscribe({
        next: () => this.refresh(),
        error: (e) => console.error('Failed to update status:', e)
      });
  }

  openFilter(id: any, roleid: any) {
    const modalRef = this.modalService.open(FilterselectroleComponent, {
      backdrop: 'static',
      keyboard: true,
      size: 'md',
      centered: true,
      windowClass: 'ngb-select-role',
      backdropClass: 'ngb-select-role-backdrop'
    });
    modalRef.componentInstance.roleid = roleid;
    modalRef.componentInstance.account_id = id;
    modalRef.result.finally(() => this.refresh());
  }



  public fetchAccountData(): void {
    const filters = {
      status: '',
      practice_id: localStorage.getItem('practiceId') || '0',
    };

    this.accountService
      .filter(
        filters,
        this.valor || '',
        this.limit,
        this.offset,
        this.sortField || '',
        this.sortDir || 'desc',
        this.enableordisable || '',
        this.accountid || ''
      )
      .subscribe({
        next: (data: ResultAccounts) => {
          this.resultAll = data;
          this.loading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.loading = false;
          console.error('Error fetching accounts:', err);
        }
      });
  }

  refresh(): void {
    this.loading = true;
    this.fetchAccountData();
  }

  // =========================================================
  // Invites utils
  // =========================================================
  private normStatus(row: any): string {
    return String(row?.status || '').trim().toLowerCase(); // 'pending' | 'accepted' | ...
  }

  canView(_row: any): boolean {
    return true;
  }

  canResend(row: any): boolean {
    return this.normStatus(row) === 'pending';
  }

  canCancel(row: any): boolean {
    return this.normStatus(row) === 'pending';
  }

  editInvite(row: any): void {
    this.openModal('invite');
    this.isEditing = true;
    this.editingInviteId = row?.id ?? null;
    this.inviteTab = 'add';

    const rawRole = row?.role?.id ?? row?.roleId ?? null;
    const rawNpi  = row?.npi ?? null;

    let tries = 0;
    const tryPatch = () => {
      const rolesReady = (this.resultRole?.length ?? 0) > 0;
      const npiReady   = (this.npiList?.length ?? 0) > 0;

      if (rolesReady && npiReady) {
        const roleVal = rawRole != null ? this.coerceRoleId(rawRole) : '';
        const npiVal  = rawNpi  != null ? this.coerceNpi(rawNpi) : '';

        this.inviteForm.patchValue({
          role: roleVal,
          npi: npiVal,
          firstName: row?.first_name ?? '',
          lastName:  row?.last_name  ?? '',
          phoneNumber: row?.phone_number ?? '',
          email: row?.email ?? ''
        });

        this.selectedRole = String(this.inviteForm.get('role')?.value ?? '');
        if (this.selectedRole === '5') {
          this.inviteForm.get('npi')?.reset();
          this.inviteForm.get('npi')?.clearValidators();
        } else {
          this.inviteForm.get('npi')?.setValidators([Validators.required]);
        }
        this.inviteForm.get('npi')?.updateValueAndValidity({ emitEvent: false });

        this.cdr.detectChanges();
        return;
      }
      if (tries++ < 10) setTimeout(tryPatch, 50);
    };

    tryPatch();
  }

  rowActions: GridAction[] = [
    { id: 'edit',   label: 'Edit',   icon: '📝' },
    { id: 'resend', label: 'Resend', icon: '🔄', visible: r => r.status === 'pending' },
    { id: 'cancel', label: 'Cancel', icon: '❌',
      visible: r => r.status !== 'expired',
      confirm: r => `Cancel invite for ${r.email}?` }
  ];

  private coerceRoleId(raw: any): any {
    const sample = this.resultRole?.[0]?.id;
    if (sample === undefined || sample === null) return raw;
    return (typeof sample === 'number') ? Number(raw) : String(raw);
  }

  private coerceNpi(raw: any): any {
    const sample = this.npiList?.[0]?.npi;
    if (sample === undefined || sample === null) return raw;
    return (typeof sample === 'number') ? Number(raw) : String(raw);
  }

  onAction(e: { actionId: string; row: any }) {
    switch (e.actionId) {
      case 'edit':   this.editInvite(e.row); break;
      case 'resend': this.resendInvite(e.row); break;
      case 'cancel': this.revokeInvite(e.row); break;
    }
  }

  openRowMenu(menu: Menu, row: any, ev: MouseEvent) {
    ev.preventDefault();
    ev.stopPropagation();

    const items: MenuItem[] = [
      { label: 'View',   icon: 'pi pi-eye',     visible: this.canView(row),   command: () => this.editInvite(row) },
      { label: 'Resend', icon: 'pi pi-refresh', visible: this.canResend(row), command: () => this.resendInvite(row) },
      ...(this.canCancel(row) ? [{ separator: true } as MenuItem] : []),
      { label: 'Cancel', icon: 'pi pi-times',   visible: this.canCancel(row), command: () => this.revokeInvite(row), styleClass: 'p-menuitem-danger' }
    ];

    this.menuItems = items.filter(i => i.visible !== false || i.separator);
    menu.toggle(ev);
  }

  // =========================================================
  // Invites form
  // =========================================================
  buildInviteForm(): void {
    this.inviteForm = this.fb.group({
      role: ['', Validators.required],
      npi: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  // =========================================================
  // Modals
  // =========================================================
  openModal(modal: ModalName): void {
    this.closeAllModals();

    switch (modal) {
      case 'changePassword':
        this.isChangePasswordModalOpen = true;
        break;

      case 'invite':
        this.isInviteModalOpen = true;

        if (!this.inviteForm) {
          this.buildInviteForm();
        } else {
          this.isEditing = false;
          this.editingInviteId = null;
          this.inviteForm.reset();
        }
        this.selectedRole = undefined;
        this.selectedNpi = null;
        this.inviteLoading = false;
        this.inviteTab = 'add';
        this.loadRoles();
        this.loadNpiList();
        break;

      case 'accounts':
        this.isAccountsModalOpen = true;
        // carga inicial del grid
        this.onAccountLazy({ first: 0, rows: this.limit, sortField: null, sortOrder: 0, sortParam: null } as any);
        break;
    }

    this.openModalCount++;
    this.syncBodyScroll();
  }

  closeModal(modal: ModalName): void {
    switch (modal) {
      case 'changePassword': if (this.isChangePasswordModalOpen) this.isChangePasswordModalOpen = false; break;
      case 'invite':         if (this.isInviteModalOpen) this.isInviteModalOpen = false; break;
      case 'accounts':       if (this.isAccountsModalOpen) this.isAccountsModalOpen = false; break;
    }
    if (this.openModalCount > 0) this.openModalCount--;
    this.syncBodyScroll();
  }

  closeAllModals(): void {
    this.isChangePasswordModalOpen = false;
    this.isInviteModalOpen = false;
    this.isAccountsModalOpen = false;
    this.openModalCount = 0;
    this.syncBodyScroll();
  }

  private syncBodyScroll(): void {
    document.body.style.overflow = this.openModalCount > 0 ? 'hidden' : 'auto';
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeAllModals();
  }

  // =========================================================
  // Invite: Catálogos + lógica Add
  // =========================================================
  loadRoles(invitation:boolean =true): void {
    const params = new HttpParams()
      .set('practice_required', 'true')
      .set('is_invitation', invitation);

    this.roleService.getroles(params).subscribe({
      next: (data) =>{
        this.resultRole = data.results;

        this.cdr.detectChanges();
      },
      error: () => this.resultRole = []
    });
  }

  loadNpiList(): void {
    const practiceId = localStorage.getItem('practiceId') || '0';
    this.invitesService.getNpiList(practiceId).subscribe({
      next: (data) => this.npiList = data.results || [],
      error: () => this.npiList = []
    });
  }

  onRoleChange(ev: any): void {
    this.selectedRole = ev?.value;
    if (this.selectedRole === '5') {
      this.selectedNpi = null;
      this.inviteForm.get('npi')?.reset();
      this.inviteForm.get('npi')?.clearValidators();
      this.inviteForm.get('npi')?.updateValueAndValidity({ emitEvent: false });
    } else {
      this.inviteForm.get('npi')?.setValidators([Validators.required]);
      this.inviteForm.get('npi')?.updateValueAndValidity({ emitEvent: false });
    }
  }

  onNpiChange(): void {
    const npiValue = this.inviteForm.get('npi')?.value;
    this.selectedNpi = this.npiList.find(n => n.npi === npiValue) || null;

    if (this.selectedNpi && this.selectedRole !== '5') {
      const [firstName, ...rest] = (this.selectedNpi.name || '').split(' ');
      const lastName = rest.join(' ');
      this.inviteForm.get('firstName')?.setValue(firstName || '');
      this.inviteForm.get('lastName')?.setValue(lastName || '');
    }
  }

  submitInvite(): void {
    if (this.inviteLoading) return;
    if (this.inviteForm.invalid) {
      FormUtils.markFormGroupTouched(this.inviteForm);
      this.alertMessage.showToast('Please fill in all required fields', 'error');
      return;
    }

    this.inviteLoading = true;

    const { firstName, lastName, email, role, phoneNumber, npi } = this.inviteForm.value;
    const practiceId = localStorage.getItem('practiceId') || '0';

    const done = () => { this.inviteLoading = false; this.cdr.detectChanges(); };

    if (this.isEditing && this.editingInviteId) {
      this.invitesService
        .editInvitation(this.editingInviteId, firstName, lastName, email, role, phoneNumber, npi, practiceId)
        .pipe(first(), finalize(done))
        .subscribe({
          next: () => {
            this.alertMessage.showToast('Invitation updated successfully!', 'success');
            this.isEditing = false;
            this.editingInviteId = null;
            this.inviteTab = 'sent';
            this.offset = 0;
            this.loadSentInvites();
          },
          error: (err) => {
            const msg = err?.error?.detail || err?.message || 'An error occurred while updating the invite.';
            this.alertMessage.showToast(msg, 'error');
          }
        });
    } else {
      this.invitesService
        .addInvitation(firstName, lastName, email, role, phoneNumber, npi, practiceId)
        .pipe(first(), finalize(done))
        .subscribe({
          next: () => {
            this.alertMessage.showToast('Invitation sent successfully!', 'success');
            this.inviteForm.reset();
            this.selectedRole = undefined;
            this.selectedNpi = null;
            this.inviteTab = 'sent';
            this.offset = 0;
            this.loadSentInvites();
          },
          error: (err) => {
            const msg = err?.error?.detail || err?.message || 'An error occurred while sending the invite.';
            this.alertMessage.showToast(msg, 'error');
          }
        });
    }
  }

  // =========================================================
  // Invite: pestaña "Sent" + Generic Grid (server-side)
  // =========================================================
  setInviteTab(tab: 'add' | 'sent'): void {
    this.inviteTab = tab;

    if (tab === 'add') {
      this.isEditing = false;
      this.editingInviteId = null;
      this.inviteForm.reset();
      this.selectedRole = undefined;
      this.selectedNpi = null;
      this.inviteForm.get('npi')?.clearValidators();
      this.inviteForm.get('npi')?.updateValueAndValidity({ emitEvent: false });
    }

    if (tab === 'sent') {
      this.offset = 0;
      this.loadSentInvites();
    }
  }

  debouncedLoadInvites(): void {
    clearTimeout(this.inviteFilterTimer);
    this.inviteFilterTimer = setTimeout(() => {
      this.offset = 0;
      this.loadSentInvites();
    }, 200);
  }

  loadSentInvites(): void {
    const practiceId = localStorage.getItem('practiceId') || '0';

    this.invitesService
      .getListInvitations(
        { search: this.sentFilter, practice_id: practiceId, ordening: this.sort },
        this.limit,
        this.offset
      )
      .pipe(first())
      .subscribe({
        next: (res: ResultInviteModel) => {
          this.result = res;
          this.cdr.detectChanges();
        },
        error: () => {
          this.result = new ResultInviteModel();
          this.cdr.detectChanges();
        }
      });
  }

  // ====== Generic Grid handlers (Invites) ======
  lazyLoadData(event: any): void {
    this.limit  = event?.rows  ?? this.limit;
    this.offset = event?.first ?? 0;

    if (event?.sortField || event?.sortParam) {
      const baseField = (event.sortParam || event.sortField || '').replace(/^-+/, '');
      this.sort = (event.sortOrder === 1 ? baseField : `-${baseField}`);
    } else {
      this.sort = '';
    }

    if (this.inviteTab === 'sent') this.loadSentInvites();
  }

  onRowSelect(event: any): void {
    const row = event?.data ?? event;
  }

  async copyInviteLink(inv: { inviteUrl: string }): Promise<void> {
    try {
      await navigator.clipboard.writeText(inv.inviteUrl);
      this.alertMessage.showToast('Invite link copied to clipboard', 'success');
    } catch {
      this.alertMessage.showToast('Could not copy link', 'error');
    }
  }

  resendInvite(inv: { id: number }): void {
    if (this.resendingId) return;
    this.resendingId = inv.id;
    this.invitesService.resendInvitation(inv.id)
      .pipe(first(), finalize(() => this.resendingId = null))
      .subscribe({
        next: () => this.alertMessage.showToast('Invitation re-sent', 'success'),
        error: () => this.alertMessage.showToast('Could not re-send invitation', 'error')
      });
  }

  revokeInvite(inv: { id: number }): void {
    if (this.revokingId) return;

    this.revokingId = inv.id;
    this.invitesService.cancelInvitation(inv.id).subscribe({
      next: () => {
        this.alertMessage.showToast('Invitation has been cancelled successfully.', 'success');
        this.loadSentInvites();
        this.revokingId = null;
      },
      error: (err) => {
        this.alertMessage.showToast('Failed to cancel the invitation. Please try again.', 'error');
        console.error(`Error cancelling invitation with ID: ${inv.id}`, err);
        this.revokingId = null;
      }
    });
  }

  // =========================================================
  // Toggles
  // =========================================================
  loadSettings(): void {
    this.twoFactorEnabled = localStorage.getItem('twoFactorEnabled') === 'true';
    this.darkModeEnabled = this.themeModeService.mode.value === 'dark';
  }

  toggleTwoFactor(): void {
    localStorage.setItem('twoFactorEnabled', String(this.twoFactorEnabled));
    this.alertMessage.showToast(
      `2-Step Verification ${this.twoFactorEnabled ? 'enabled' : 'disabled'}`,
      this.twoFactorEnabled ? 'success' : 'error'
    );
  }

  toggleDarkMode(): void {
    // Mismo mecanismo que el botón del header: persiste en localStorage y recarga
    this.themeModeService.switchMode(this.darkModeEnabled ? 'dark' : 'light');
  }

  // =========================================================
  // Misc (solo para la tabla dummy antigua)
  // =========================================================
  private parseDate(value: string): number {
    const d = new Date(value);
    const t = d.getTime();
    return Number.isNaN(t) ? Number.NEGATIVE_INFINITY : t;
  }

  sortUsers(column: keyof User, keepDirection = false): void {
    if (!keepDirection) {
      if (this.sortColumn === column) this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      else { this.sortColumn = column; this.sortDirection = 'asc'; }
    } else {
      this.sortColumn = column;
    }

    const dir = this.sortDirection === 'asc' ? 1 : -1;

    this.filteredUsers.sort((a, b) => {
      const av = a[this.sortColumn];
      const bv = b[this.sortColumn];

      if (this.sortColumn === 'lastLogin') {
        const ad = this.parseDate(String(av));
        const bd = this.parseDate(String(bv));
        return (ad - bd) * dir;
      }

      if (typeof av === 'boolean' && typeof bv === 'boolean') {
        return (av === bv ? 0 : av ? -1 : 1) * dir;
      }

      return String(av).localeCompare(String(bv)) * dir;
    });

    this.updatePagedUsers();
  }

  updatePagedUsers(): void {
    this.totalPages = Math.max(1, Math.ceil(this.filteredUsers.length / this.usersPerPage));
    const start = (this.currentPage - 1) * this.usersPerPage;
    this.pagedUsers = this.filteredUsers.slice(start, start + this.usersPerPage);
  }

  handlePagination(action: 'firstPage' | 'prevPage' | 'nextPage' | 'lastPage'): void {
    if (action === 'firstPage') this.currentPage = 1;
    else if (action === 'prevPage') this.currentPage = Math.max(1, this.currentPage - 1);
    else if (action === 'nextPage') this.currentPage = Math.min(this.totalPages, this.currentPage + 1);
    else if (action === 'lastPage') this.currentPage = this.totalPages;
    this.updatePagedUsers();
  }

  onUserStatusChange(event: Event, user: User): void {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = !!checkbox?.checked;
    user.status = isChecked;
    this.updateUserStatus(user, isChecked);
  }

  updateUserStatus(user: User, status: boolean): void {
    user.status = status;
    this.alertMessage.showToast(`${user.name}'s status ${status ? 'activated' : 'deactivated'}`, 'success');
  }

  // =========================================================
  // Misc
  // =========================================================
  openReportForm(): void {
    const url = 'https://forms.monday.com/forms/1bedf197ce04c17470e11bab777f0ce8?r=use1';
    window.open(url, '_blank', 'noopener');
  }

  showFirstNameActionMenu(): void {
    this.alertMessage.showToast('Auto-fill from Directory / Clear Field options would appear here.', 'info');
    this.newInvite.firstName = 'John';
    this.alertMessage.showToast('First name auto-filled from directory', 'success');
  }

  trackByUser(_: number, u: User) { return `${u.name}-${u.role}`; }

  protected readonly HTMLInputElement = HTMLInputElement;
}
